<div class="PGImportTree container-fluid">
    @if (importType == 'dhm') {
        <div class="PGImportTree-Filters row mb-2">
            <div class="col-6 mb-2">
                <label class="mb-1">
                    <b>{{ 'pg-import-tree.filter-province' | locTranslate }}</b>
                </label>
                <app-pg-select [options]="DHMTaxonomiesOptions?.province" [multi]="true" [(ngModel)]="DHMTaxonomiesProvinceSelected" (ngModelChange)="onFilterChange()"></app-pg-select>
            </div>
            <div class="col-6 mb-2">
                <label class="mb-1">
                    <b>{{ 'pg-import-tree.filter-city' | locTranslate }}</b>
                </label>
                <app-pg-select [options]="DHMTaxonomiesOptions?.city" [multi]="true" [(ngModel)]="DHMTaxonomiesCitySelected" (ngModelChange)="onFilterChange()"></app-pg-select>
            </div>
            <div class="col-6 mb-2">
                <label class="mb-1">
                    <b>{{ 'pg-import-tree.filter-type' | locTranslate }}</b>
                </label>
                <app-pg-select [options]="DHMTemplatesOptions" [multi]="true" [(ngModel)]="DHMTemplatesSelected" (ngModelChange)="onFilterChange()"></app-pg-select>
            </div>
            <div class="col-6 mb-2">
                <label class="mb-1">
                    <b>{{ 'pg-import-tree.filter-search' | locTranslate }}</b>
                </label>
                <div class="input-group">
                    <div class="input-group-text">
                        <i class="fa-regular fa-search"></i>
                    </div>
                    <input class="form-control form-control" [(ngModel)]="searchVal" (change)="onFilterChange()"/>
                </div>
            </div>
        </div>
    }
    @if (importType == 'eppoi') {
        <div class="PGImportTree-Filters row mb-2">
            <div class="col-6 mb-2">
                <label class="mb-1">
                    <b>{{ 'pg-import-tree.filter-municipality' | locTranslate }}</b>
                </label>
                @if (EPPOIMunicipalityOptions) {
                    <app-pg-select [options]="EPPOIMunicipalityOptions" [multi]="false" display="oneLine" [(ngModel)]="EPPOIMunicipalitySelected" (ngModelChange)="onFilterChange()"></app-pg-select>
                }
                @else {
                    <app-pg-loading [isSmall]="true"></app-pg-loading>
                }
            </div>
        </div>
    }
    <div class="PGImportTree-Main row">
        @if(treeData['']) {
            <div class="col-12">
                <ng-container *ngTemplateOutlet="directoryTemplate;context:{ directory: treeData[''] }"></ng-container>
            </div>
        }
    </div>
</div>

<ng-template #directoryTemplate let-directory="directory">
    @if(getSearchParams()) {
        @if(directory.progress.files.totalCount; as count) {
            <div class="PGImportTree-Header mb-3 pb-2 border-bottom d-flex align-items-center">
                <div>{{ 'pg-import-tree.directory-count' | locTranslate:'count':count }}</div>
                <div class="ms-3 d-flex align-items-center">
                    <button class="btn btn-sm btn-primary" [disabled]="isSelectingAll" (click)="toggleSelectAll('')">
                        <i class="fa-regular fa-asterisk"></i>
                        @if(isAllSelected('')) {
                            <span>{{ 'pg-import-tree.deselect-all' | locTranslate }}</span>
                        }
                        @else {
                            <span>{{ 'pg-import-tree.select-all' | locTranslate }}</span>
                        }
                    </button>
                    @if(isSelectingAll) {
                        <div class="progress ms-3">
                            <div class="progress-bar bg-primary" [style.transform]="'scale(' + (directory.files.length / directory.progress.files.totalCount) + ', 1)'"></div>
                        </div>
                    }
                </div>
            </div>
        }
    }

    <div class="PGImportTree-Directory"> 
        @if(isSelectingAll) {
            <app-pg-loading></app-pg-loading>
        }
        @else if(directory.open) {
            <div class="PGImportTree-Directory-Items ms-2 ps-3">
                @if(!directory.loading && !canLoadMoreData(directory.id) && directory.directories.length == 0 && directory.files.length == 0) {
                    <div class="p-1 text-muted">{{ 'pg-import-tree.directory-empty' | locTranslate }}</div>
                }
                @if(directory.directories.length > 0) {
                    @for(item of directory.directories; track item) {
                        @if(treeData[item.id]; as child) {
                            <div class="p-1">
                                <div class="d-flex align-items-center">
                                    <button class="btn btn-link p-0 border-0 text-primary" (click)="toggleDirectoryOpen(child)">
                                        <i class="fa-regular fa-fw fa-folder-{{child.open ? 'open' : 'closed'}}"></i>
                                        <span>{{ item.name }}</span>
                                    </button>
                                    @if(item.contents) {
                                        <small class="text-muted ms-1">({{ item.contents.directories + item.contents.files }})</small>
                                    }
                                </div>
                                <ng-container *ngTemplateOutlet="directoryTemplate;context:{ directory: treeData[item.id] }"></ng-container>
                            </div>
                        }
                    }
                }
                @if(directory.files.length > 0) {
                    @for(item of directory.files; track item) {
                        <div class="p-1">
                            <div class="d-flex align-items-center">
                                @if(item.resource) {
                                    <input type="checkbox" class="me-1" [ngModel]="isSelected(item.resource, item.id)" (ngModelChange)="setSelected(item.resource, item.id, $event, directory, item)">
                                    <button class="btn btn-link py-0 px-1 me-1" (click)="openPreview(item.resource, item.id, directory, item)">
                                        <i class="fa-regular fa-magnifying-glass fa-fw"></i>
                                    </button>
                                    <span>{{ 'RESOURCES.' + item.resource + '.name' | locTranslate }} - {{ item.id }} - {{ item.name }}</span>
                                    @if(isSelected(item.resource, item.id) && isAlreadyImported(item.resource, item.id)) {
                                        <span class="badge text-bg-warning ms-2">{{ 'pg-import-tree.already-imported' | locTranslate }}</span>
                                    }
                                }
                                @else {
                                    <input type="checkbox" class="me-1" [disabled]="true">
                                    <button class="btn btn-link py-0 px-1 me-1" [disabled]="true">
                                            <i class="fa-regular fa-times fa-fw"></i>
                                    </button>
                                    <span class="text-muted">{{ 'pg-import-tree.file-no-resource' | locTranslate }} - {{ item.id }} - {{ item.name }}</span>
                                }
                            </div>
                        </div>
                    }
                }
                @if(directory.loading) {
                    <div class="p-1 d-flex">
                        <app-pg-loading [isSmall]="true"></app-pg-loading>
                    </div>
                }
                @if(canLoadMoreData(directory.id)) {
                    <app-pg-view-more [hidden]="directory.loading" (viewMore)="loadMoreData(directory.id)"></app-pg-view-more>
                }
            </div>
        }
    </div>
</ng-template>
